import React from "react";
import DashboardHeader from "./controls/DashboardHeader";
import {ClientFollowUps} from "./controls/ClientFollowUps";
import StatsPanel from "./controls/StatCard/StatsPanel";

export default function Dashboard() {

    return (
        <div className="flex gap-3 bg-slate-50 flex-col relative z-0 overflow-y-scroll p-3 sm:p-1">
            {/* Classes you’re teaching / planning */}
            {/*<DashboardHeader*/}
            {/*    title="Classes"*/}
            {/*    description="Whatcha teaching next?"*/}
            {/*>*/}
            {/*    <div className="mt-3">*/}
            {/*        <ClassPlanningHorizontalList />*/}
            {/*    </div>*/}
            {/*</DashboardHeader>*/}

            <StatsPanel/>

            {/* Follow-ups */}
            <DashboardHeader
                title="Follow ups"
                description="The clients ready for a nudge.">
                <ClientFollowUps/>
            </DashboardHeader>

            {/* Next steps */}
            {/*<DashboardHeader*/}
            {/*    title="Next steps"*/}
            {/*    description="The next steps/actions for your clients"*/}
            {/*>*/}
            {/*    <NextStepsPerContact/>*/}
            {/*</DashboardHeader>*/}

            {/* Daily Call-Upons */}
            {/* <DashboardHeader
        title="Daily Call-Upons"
        description="A rotation of call upons for those you support"
        menu={
          <DropMenu
            menuButtonClassName="p-1.5 hover:bg-indigo-500 text-white relative rounded-full bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            imageElement={<PlusIcon className="h-5 w-5" aria-hidden="true" />}
          >
            <DropMenuItem title="Add" to="/callupons/new" />
          </DropMenu>
        }
      >
        <PrayersAndCallUpons />
      </DashboardHeader> */}
        </div>
    );
}
